import { User } from '../domain/user';
import { Pronouns, Title } from '../../Person';
import { RUser } from '../remote/user';
import { parseISO } from 'date-fns';
import { mapRImage } from '../../../api/helpers';
import { mapInstitution, mapInstitutions } from '../../Institution/mapping/mapInstitution';
import { mapProjects, Project } from '../../Project';

export const mapUser = (user: RUser): User => {
    const {
        firstname,
        lastname,
        password,
        title,
        pronouns,
        email,
        phone,
        motivation,
        institution,
        favouriteCompanies,
        favouriteProjects,
        jobTitle,
        isConfirmed,
        hasApproval,
        createdAt,
        updatedAt,
        publishedAt,
        profilePicture,
        administratedInstitution
    } = user;

    return {
        id: user.id.toString(),
        createdAt: parseISO(createdAt),
        updatedAt: parseISO(updatedAt),
        password: password,
        publishedAt: publishedAt ? parseISO(publishedAt) : null,
        firstname,
        lastname,
        title: title ? (title as Title) : undefined,
        pronouns: pronouns ? (pronouns as Pronouns) : undefined,
        email,
        phone: phone ?? undefined,
        profilePicture: mapRImage(profilePicture),
        motivation: motivation ?? undefined,
        institution: institution ? mapInstitution(institution) : undefined,
        jobTitle: jobTitle ?? undefined,
        favouriteCompanies: mapInstitutions(favouriteCompanies ?? []),
        favouriteProjects: mapProjects(favouriteProjects ?? []) as Project[],
        isAdmin: administratedInstitution !== null ?  true : false,
        isConfirmed,
        hasApproval
    };
};

export const mapUsers = (users?: RUser[] | null) =>
    users ? users.map((user) => mapUser(user)) : [];
